import { render, staticRenderFns } from "./ServiceSea.vue?vue&type=template&id=3bbf1d10&"
import script from "./ServiceSea.vue?vue&type=script&lang=js&"
export * from "./ServiceSea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports